/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-badge-indicator {
  align-items: center;
  background-color: var(--qds-theme-feedback-message-neutral);
  border-radius: var(--qds-control-toggle-indicator-rounded-border-radius);
  display: flex;
  height: var(--qds-badge-indicator-standard-height);
  justify-content: center;
  width: var(--qds-badge-indicator-standard-height);
}

.qds-stroke-ring {
  border: var(--qds-badge-border-width) solid
    var(--qds-theme-feedback-message-neutral-contrast);
}

.qds-sr-only {
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
}

[data-status='error'] {
  background-color: var(--qds-theme-feedback-message-critical);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='info'] {
  background-color: var(--qds-theme-feedback-message-informational);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='neutral'] {
  background-color: var(--qds-theme-feedback-availability-unavailable);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='success'] {
  background-color: var(--qds-theme-signature-color-default);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='warning'] {
  background-color: var(--qds-theme-feedback-message-important);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-size='small'] {
  height: var(--qds-badge-indicator-small-height);
  width: var(--qds-badge-indicator-small-height);
}

[data-size='standard'] {
  height: var(--qds-badge-indicator-standard-height);
  width: var(--qds-badge-indicator-standard-height);
}

[data-size='large'] {
  height: var(--qds-badge-indicator-large-height);
  width: var(--qds-badge-indicator-large-height);
}

[data-size='hero'] {
  height: var(--qds-badge-indicator-hero-height);
  width: var(--qds-badge-indicator-hero-height);
}
